'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ErrorDataUnavailable } from '@/components/common/Error';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';
const VaultYourTransactionsError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-sm flex flex-col"><SubSectionTitle>Your transactions</SubSectionTitle><ErrorDataUnavailable minHeight="478px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(VaultYourTransactionsError);